import { render, staticRenderFns } from "./CodVerificationOnboarding.vue?vue&type=template&id=aefb5f74&scoped=true&"
import script from "./CodVerificationOnboarding.vue?vue&type=script&lang=js&"
export * from "./CodVerificationOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb5f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefb5f74')) {
      api.createRecord('aefb5f74', component.options)
    } else {
      api.reload('aefb5f74', component.options)
    }
    module.hot.accept("./CodVerificationOnboarding.vue?vue&type=template&id=aefb5f74&scoped=true&", function () {
      api.rerender('aefb5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Automation/CodVerificationOnboarding.vue"
export default component.exports